export {
  Widget,
  TitleFontWeight,
  TitleFontSize,
  type WidgetProps,
} from './Widget';
